import React from "react";
import classes from "./AlliedServices.module.scss";
import HeroSection from "./HeroSection/HeroSection";
import HighlightSection from "./HighlightSection/HighlightSection";
import Vendors from "./Vendors/Vendors";
import SuggestedServices from "./SuggestedServices/SuggestedServices";
import FAQs from "./FAQs/FAQs";
import AdBanner from "./Banner/AdBanner";

const AlliedServices = (props: any) => {
  const alliedServiceData = props?.pageData?.[0] ?? {};
  const alliedServicesCardData = props?.alliedServicesCardData ?? {};
  const countriesList = props?.countriesList ?? [];
  const { featureShowcase, vendors, vendorsSection, faq, banner, serviceSuggestion } = alliedServiceData;

  return (
    <main className={classes["allied-services-section"]}>
      <HeroSection alliedServiceData={alliedServiceData} />

      {featureShowcase && <HighlightSection featureShowcaseData={featureShowcase} />}

      {vendors?.length > 0 && (
        <Vendors
          vendorsData={vendors}
          vendorsSectionData={vendorsSection}
          destinationOptions={countriesList?.map((country: any) => ({ label: country.name, value: country.name }))}
        />
      )}

      {alliedServicesCardData && (
        <SuggestedServices
          heading={serviceSuggestion?.title}
          subtext={serviceSuggestion?.description}
          alliedServicesCardData={alliedServicesCardData}
          excludeCurrentSlug={true}
        />
      )}

      {faq && <FAQs faqData={faq} />}

      {banner && <AdBanner bannerData={banner} />}
    </main>
  );
};

export default AlliedServices;
